<template>
  <div>
    <b-modal
      ref="import-product-modal"
      hide-footer
      title="Thêm sản phẩm từ Excel"
      id="modal-prevent-closing"
      size="xl"
    >
      <b-row>
        <b-col>
          <div class="form-group">
            <span>
              <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
              format, hoặc có thể tải ở
              <a :href="urlExcel">đây</a>
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span> <b>Bước 2:</b> Tiến hành Import </span>
          <div style="padding-top: 15px">
            <b-form-file
              placeholder="Hãy chọn một tập tin"
              @change="selectFile"
              v-model="file"
              ref="file-input"
              class="mb-2"
            ></b-form-file>
          </div>
        </b-col>
      </b-row>
      <b-container class="mt-4 pl-0 pr-0" v-show="importItems.length > 0">
        <h5 class="d-flex align-items-center">
          <span
            >Danh sách sản phẩm từ file excel( Tổng:
            {{ importItems.length }} sản phẩm)</span
          >
          <span
            v-if="isValidating"
            class="d-inline-flex align-items-center ml-3 text-muted font-size-sm font-weight-normal"
          >
            <b-spinner small variant="secondary" class="mr-2"></b-spinner>
            Đang kiểm tra trạng thái sản phẩm…
          </span>
        </h5>
        <b-alert
          :show="errorCount > 0"
          variant="danger"
          class="py-2 px-3 mb-3"
        >
          Có {{ errorCount }}/{{ importItems.length }} dòng Mã lô không hợp lệ — vui
          lòng sửa file Excel rồi import lại.
        </b-alert>
        <b-table
          id="my-table"
          class="myTable"
          responsive
          bordered
          hover
          :fields="fieldImport"
          :items="importItems"
          :per-page="10"
          :current-page="currentPage"
          :tbody-tr-class="rowClass"
        >
          <template v-slot:cell(productBatchStockCode)="row">
            <span v-text="row.item.productBatchStockCode || row.item.batchCode"></span>
          </template>
          <template v-slot:cell(error)="row">
            <span
              v-if="row.item.error"
              class="text-danger font-size-sm"
              v-text="row.item.error"
            ></span>
            <span v-else class="text-success">
              <i class="fas fa-check"></i>
            </span>
          </template>
          <template v-slot:cell(productName)="row">
            <span v-text="row.item.productCode"></span>
            <br />
            <span v-text="row.item.productName"></span>
            <span
              v-if="isNonSellableProduct(row.item)"
              class="label label-inline label-light-danger ml-1"
              >Ngừng bán</span
            >
          </template>

          <template v-slot:cell(unitPrice)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.unitPrice)"></span>
            </div>
          </template>
          <template v-slot:cell(totalAmount)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.totalAmount)"></span>
            </div>
          </template>
          <template v-slot:cell(quantity)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.quantity)"></span>
            </div>
          </template>
          <template v-slot:cell(discountAmount)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.discountAmount)"></span>
            </div>
          </template>
        </b-table>
        <b-pagination
          v-show="importItems.length > 10"
          v-model="currentPage"
          :total-rows="importItems.length"
          :per-page="10"
          aria-controls="my-table"
        ></b-pagination>
      </b-container>
      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="validData"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModalImportProduct"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>

<script>
import {
  makeToastSuccess,
  makeToastFaile,
  convertPrice,
} from '../../../utils/common';
import { BASE_URL } from './../../../utils/constants';
import { PRODUCT_STATUS } from './../../../utils/enum';
import xlsx from 'xlsx';
import ApiService from '@/core/services/api.service';
import { v4 } from 'uuid';

export default {
  props: {
    type: {},
    storeId: {},
    // Loại phiếu của màn cha có được ghi nhận sản phẩm ngừng bán không.
    includeNonSellable: {
      type: Boolean,
      default: false,
    },
    // Luồng kho nào - BE dựa vào đây để biết được mở tới đâu.
    // KHÔNG suy ra được từ `type`: cả Chuyển kho lẫn Xuất trả NCC đều gửi type = 2.
    nonSellableContext: {
      type: String,
      default: 'transfer-stock',
    },
  },
  data() {
    return {
      importItems: [],
      file: null,
      excellist: [],
      currentPage: 1,
      urlExcel: BASE_URL + 'templates/download?type=export-stock-slip-import',
      fieldImport: [
        {
          key: 'productName',
          label: 'Sản phẩm',
        },
        {
          key: 'productImei',
          label: 'IMEI',
        },
        {
          key: 'productBatchStockCode',
          label: 'Mã lô',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá',
        },
        {
          key: 'discountAmount',
          label: 'Chiết khấu',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
        },
        {
          key: 'error',
          label: 'Trạng thái',
        },
      ],
      isValidating: false,
    };
  },
  computed: {
    errorCount() {
      return this.importItems.filter((item) => item.error).length;
    },
  },
  created() {},
  methods: {
    rowClass(item) {
      if (item && item.error) return 'table-danger';
      return '';
    },
    selectFile(event) {
      this.importItems = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx'
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellist = excellist;
          this.excellist.map((element) => {
            const quantity = element['Số lượng'] ? element['Số lượng'] : 0;
            const discountAmount = element['Chiết khấu']
              ? element['Chiết khấu']
              : 0;
            const unitPrice = element['Đơn giá'] ? element['Đơn giá'] : 0;
            const totalAmount = quantity * unitPrice - discountAmount;

            const data = {
              productName: element['Tên sản phẩm']
                ? element['Tên sản phẩm']
                : '',
              productCode: element['Mã sản phẩm'] ? element['Mã sản phẩm'] : '',
              productImei: element['IMEI'] ? element['IMEI'] : '',
              // HM3.2: đọc cột "Mã lô" từ Excel để BE validate + gán lô đúng.
              batchCode: element['Mã lô'] ? String(element['Mã lô']).trim() : '',
              productBatchStockCode: '',
              error: '',
              unitPrice: unitPrice,
              quantity: quantity,
              discountAmount: discountAmount,
              totalAmount: totalAmount,
            };
            this.importItems.push(data);
          });
          this.refreshPreviewStatus();
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },
    showModal: function () {
      this.importItems = [];
      this.excellist = [];
      this.$refs['import-product-modal'].show();
    },
    hideModalImportProduct() {
      this.$refs['import-product-modal'].hide();
    },
    buildPayload() {
      return {
        listData: this.importItems,
        storeId: this.storeId,
        type: this.type,
        ...(this.includeNonSellable && {
          includeNonSellable: '1',
          context: this.nonSellableContext,
        }),
      };
    },
    /**
     * Lấy trạng thái sản phẩm để hiện badge trên preview ngay khi chọn file.
     * Chỉ ĐỌC - quyền ghi vẫn do `validData` quyết định. Màn không thuộc phạm vi thì
     * bỏ qua, giữ nguyên luồng cũ (chỉ gọi API một lần lúc bấm Lưu).
     */
    async refreshPreviewStatus() {
      if (!this.includeNonSellable || !this.importItems.length || !this.storeId) {
        return;
      }
      this.isValidating = true;
      try {
        const response = await ApiService.post(
          'stock-slips/valid-data-import',
          this.buildPayload()
        );
        const { status, data } = response.data;
        // `valid-data-import` kiểm tất-cả-hoặc-không: sai một dòng là không trả `data`
        // nên cả bảng mất badge. Im lặng ở đây, lỗi thật báo lúc bấm Lưu.
        if (status !== 1 || !Array.isArray(data)) {
          return;
        }
        // Ghép theo index: BE trả đúng thứ tự và đúng một dòng cho mỗi dòng gửi lên.
        // Không ghép theo mã vì người dùng có thể điền mã vạch, BE trả lại productCode.
        this.importItems = this.importItems.map((item, index) => ({
          ...item,
          status: (data[index] || {}).status,
        }));
      } catch (error) {
        return;
      } finally {
        this.isValidating = false;
      }
    },
    // Chỉ Ngừng bán (3); Hết hàng (4) ngoài phạm vi.
    isNonSellableProduct(item = {}) {
      return item.status === PRODUCT_STATUS.STOP_SELLING;
    },
    validData: async function () {
      await ApiService.post(
        'stock-slips/valid-data-import',
        this.buildPayload()
      )
        .then((response) => {
          const { status, message, data } = response.data;
          if (status === 1) {
            makeToastSuccess(message);
            // Mảng CỤC BỘ. Trước đây dùng biến chung `listResult` không bao giờ reset
            // nên import lần 2 gửi lại cả dữ liệu lần 1 -> danh sách bị nhân đôi.
            // Giữ NGUYÊN dòng BE trả (lô, cờ isBatchStockProduct, trạng thái…) — chỉ thêm id + chuẩn hoá IMEI.
            // Màn cha dựng dòng phiếu qua 1 helper (toStockSlipItemFromImport), không đổi tên field 2 lần
            // ở 2 tầng (field mới của BE rơi ở tầng giữa — t100730).
            const listResult = (data || []).map((element) => ({
              ...element,
              id: v4(),
              imeiCode: (element.imeiCode || '')
                .replace(/[,]/g, '\n')
                .replace(/[ ]/g, ''),
            }));
            this.hideModalImportProduct();
            this.$emit('validData', listResult);
          } else {
            makeToastFaile(message);
            // HM3.2: BE trả kèm per-row data khi lỗi Mã lô -> highlight từng dòng, GIỮ modal
            // để user sửa Excel rồi import lại (chặn import, Rule 45).
            if (Array.isArray(data) && data.length) {
              this.importItems = this.importItems.map((item, index) => {
                const row = data[index] || {};
                return {
                  ...item,
                  error: row.error || '',
                  productBatchStockCode:
                    row.productBatchStockCode ||
                    item.productBatchStockCode ||
                    item.batchCode ||
                    '',
                };
              });
            }
          }
        })
        .catch((err) => {
          makeToastFaile(err);
        });
    },
    convertPrice(number) {
      return convertPrice(number);
    },
  },
};
</script>